<template>
  <div class="animated fadeIn">
    <transition name="fade">
      <b-card no-body>
        <div slot="header">
          <i class="fa fa-search mr-2"></i>
          <strong>Recherche</strong>
          <div class="card-header-actions">
            <b-link class="card-header-action btn-minimize" v-b-toggle.collapse1>
              <span class="when-opened">
                <i class="icon-arrow-down"></i>
              </span>
              <span class="when-closed">
                <i class="icon-arrow-up"></i>
              </span>
            </b-link>
          </div>
        </div>
       <b-collapse id="collapse1">
          <b-card-body>
            <b-form v-on:submit.prevent="">
              <b-row>
                <b-col sm="2">
                  <b-form-group>
                    <label for="date_du"><strong>Période du</strong></label>
                    <b-form-input type="date" id="date_du" v-model="date_du"></b-form-input>
                    <span class="field-error">{{ errors.date_du }}</span>
                  </b-form-group>
                </b-col>
                <b-col sm="2">
                  <b-form-group>
                    <label for="date_au"><strong>Au</strong></label>
                    <b-form-input type="date" id="date_au" v-model="date_au"></b-form-input>
                    <span class="field-error">{{ errors.date_au }}</span>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="4">
                  <b-form-group >
                    <label for="nom"><strong>Nom</strong></label>
                    <b-form-input type="text" id="nom" v-model="nom"></b-form-input>
                    <span class="field-error">{{ errors.nom }}</span>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group >
                    <label for="prenom"><strong>Prénom</strong></label>
                    <b-form-input type="text" id="prenom" v-model="prenom"></b-form-input>
                    <span class="field-error">{{ errors.prenom }}</span>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="4">
                  <b-form-group >
                    <label for="type_action"><strong>Type d'action</strong></label>
                     <b-form-select v-model="type_action" :options="list_action"></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group >
                    <label for="parametre"><strong>Détail</strong></label>
                    <b-form-input type="text" id="parametre" v-model="parametre"></b-form-input>
                    <span class="field-error">{{ errors.parametre }}</span>
                  </b-form-group>
                </b-col>
              </b-row>
              <div slot="footer">
                <b-button type="button" @click.prevent="clearForm()" size="md" variant="secondary" class="mr-1">
                  <i class="fa fa-eraser"></i> Effacer
                </b-button>
                <b-button type="enter" @click.prevent="search" size="md" variant="primary">
                  <i class="fa fa-search"></i> Rechercher
                </b-button>
              </div>
            </b-form>
          </b-card-body>
        </b-collapse>
      </b-card>
    </transition>

    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i>
        <strong>Fil des Opérations</strong>
      </b-card-header>
      <b-card-body>
        <v-client-table :columns="columns" :data="items" :options="options">
          <div v-if="props.row.utilisateur_id" slot="utilisateur_id" slot-scope="props">
            <span v-if="!isEmpty(props.row.original_user_id) && props.row.original_user_id !== props.row.utilisateur_id">{{ props.row.utilisateur_original }} en tant que {{ props.row.utilisateur }}</span>
            <span v-else> {{ props.row.utilisateur_original }} </span>
          </div>
          <div v-if="props.row.date_action" slot="date_action" slot-scope="props">
            <span class="badge badge-success p-2">{{ getFormattedDateTime(props.row.date_action) }}</span>
          </div>
          <div v-if="props.row.utilisateur_ip" slot="utilisateur_ip" slot-scope="props" class="slot-number">
            <span>{{ props.row.utilisateur_ip }}</span>
          </div>
          <div v-if="props.row.objet" slot="objet" slot-scope="props">
            <span v-if="props.row.identifiant_modifie !== null && props.row.action.includes('Utilisateur : Authentification')">
              <a class="" href="#" @click.prevent="editParam(props.row.identifiant_modifie, props.row.categorie)">{{ props.row.objet }}</a>
            </span>
            <span v-else v-html="props.row.objet"></span>
          </div>
        </v-client-table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '@/utils/auth';
import { isEmpty } from "@/utils/fileHelper";
import { formatDateTime } from "@/utils/communHelper";

export default {
  data() {
    return {
      nom: "",
      prenom: "",
      parametre: "",
      date_du: "",
      date_au: "",
      type_action: "Tous",
      list_action: [],
      noSearch: 'noSearch',
      columns: [
        "date_action",
        "utilisateur_id",
        "utilisateur_ip",
        "action",
        "objet"
      ],
      items: [],
      options: {
        headings: {
          date_action: "Date / Heure",
          utilisateur_id: "Utilisateur",
          utilisateur_ip: "Adresse IP",
          action: "Type d'action",
          objet: "Détail",
        },
        columnsClasses: {
          date_action: "date-header",
        },
        sortable: ["utilisateur_original", "action","date_action"],
        filterable: ["utilisateur_original", "action"],
        perPage: 30,
        perPageValues: [30, 200, 500],
        texts: {
          filterPlaceholder: "Utilisateur, Action"
        }
      },
      errors: { nom: '', prenom: '', parametre: '', date_du: '', date_au: ''},
      isEmpty,
    }
  },
  mounted() {
    //this.all()
    this.search()
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl()
    this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken()
    this.$axios.defaults.headers.common["Accept"] = "application/json"
    this.$axios.defaults.headers.common["Provider"] = getProvider()

    // let defaultDate = ("00" + new Date().getDate()).slice(-2) + "/"
    //     + ("00" + (new Date().getMonth() + 1)).slice(-2)
    //     + "/" + new Date().getFullYear();

    let defaultDate = new Date().getFullYear() + "-" + ("00" + (new Date().getMonth() + 1)).slice(-2) + "-" + ("00" + new Date().getDate()).slice(-2);

    this.date_du = defaultDate;
    this.date_au = defaultDate;

    this.allTypeAction()
  },
  methods: {
    all() {
      let self = this;
      this.$store.commit("IS_LOADING", true);
      this.$axios
        .get("/administration/operations")
        .then(response => {
          this.$store.commit("IS_LOADING", false);
          this.items = response.data.operations;
        })
        .catch(function(error) {
          self.$store.commit("IS_LOADING", false);
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
            showConfirmButton: false,
            timer: 5000
          });
        });
    },
    allTypeAction() {
      this.list_action = [];
      let self = this;
      this.$store.commit("IS_LOADING", true)
      this.$axios
        .get("/administration/operations/listAction")
        .then(response => {
          this.$store.commit("IS_LOADING", false)
          for (let element of response.data.typeActions){
            this.list_action.push(element.action)
          }
          this.list_action.unshift('Tous');
        })
        .catch(function(error) {
          self.$store.commit("IS_LOADING", false);
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
            showConfirmButton: false,
            timer: 5000
          });
        });
    },
    search() {
      this.noSearch = ''
      let self = this;
      let dataPost = {}
      dataPost.nom = this.nom
      dataPost.prenom = this.prenom
      dataPost.objet = this.parametre
      dataPost.action = this.type_action
      dataPost.date_du = this.date_du
      dataPost.date_au = this.date_au
      dataPost.noSearch = this.noSearch

      this.$store.commit("IS_LOADING", true);
      this.$axios
        .post("/administration/operations/search", dataPost)
        .then(response => {
          this.$store.commit("IS_LOADING", false);
          this.items = response.data.operations;
        })
        .catch(function(error) {
          self.$store.commit("IS_LOADING", false);
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
            showConfirmButton: false,
            timer: 5000
          });
        });
    },
    editParam(id, categorie) {
      if (categorie === 'Utilisateur') {
        this.$router.push({ path: "/administration/users/edit/" + id })
      }
      if (categorie === 'Bénéficiaire') {
        // this.$router.push({ path: "/espace-beneficiaire/beneficiaires/fiche/" + id })
        window.location.href = "/espace-beneficiaire/beneficiaires/fiche/" + id
      }
      if (categorie === 'Droit') {
        this.$router.push({ path: '/administration/rules/edit/' + id })
      }
      if (categorie === 'Actualité') {
        // this.$router.push({ path: '/espace-beneficiaire/actualites/edit/' + id })
        window.location.href = "/espace-beneficiaire/actualites/edit/" + id
      }
      if (categorie === 'Sujet') {
        // this.$router.push({ path: '/espace-beneficiaire/gestion-des-sujets/edit/' + id })
        window.location.href = "/espace-beneficiaire/gestion-des-sujets/edit/" + id
      }
      if (categorie === 'FAQ') {
        // this.$router.push({ path: '/espace-beneficiaire/gestion-des-faq/edit/' + id })
        window.location.href = "/espace-beneficiaire/gestion-des-faq/edit/" + id
      }
      if (categorie === 'Consignes Produit') {
        window.location.href = "/espace-gestion/consignes-produit/edit/" + id
      }
      if (categorie === 'Consignes Blocage') {
        window.location.href = "/espace-gestion/consignes-blocage/edit/" + id
      }
      if (categorie === 'Espace Gestion Actualité') {
        window.location.href = "/espace-gestion/actualite/details/" + id
      }
      if (categorie === 'Groupe Siren') {
        window.location.href = "/espace-gestion/groupes-siren/edit/" + id
      }
      if (categorie === 'Espaces') {
        window.location.href = "/administration/espaces/edit/" + id
      }
      if (categorie === 'Profil') {
        window.location.href = "/administration/profiles/edit/" + id
      }
      if (categorie === 'Modules') {
        window.location.href = "/administration/modules/edit/" + id
      }
      if (categorie === 'Statuts') {
        window.location.href = "/administration/statuts/edit/" + id
      }
    },
    checkIdentifiant(id) {
      let self = this
      this.$store.commit("IS_LOADING", true)
      this.$axios
        .post("/administration/operations/identifiantModifie", id)
        .then(response => {
          this.$store.commit("IS_LOADING", false)
          this.items = response.data.operations
        })
        .catch(function(error) {
          self.$store.commit("IS_LOADING", false)
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
            showConfirmButton: false,
            timer: 5000
          })
        })
    },
    formatDate(textDate) {
      let date = textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
      return date;
    },
    getFormattedDateTime(textDate) {
        return formatDateTime(textDate, '/');
    },
    clearErrors() {
      this.errors.nom = ''
      this.errors.prenom = ''
      this.errors.date_du = ''
      this.errors.date_au = ''
      this.errors.parametre = ''
    },
    clearForm() {
      this.nom = ''
      this.prenom = ''
      this.date_du = ''
      this.date_au = ''
      this.parametre = ''
      this.type_action = 'Tous'
    }
  }
}

</script>

<style scoped>

</style>
